<template>
  <sc-table
    :data="lote.historyList">

    <template slot-scope="props">
      <sc-table-column
        label="Data"
        field="date"
        width="90">
        {{ props.row.modified | date('DD/MM/YYYY HH:mm:ss') }}
      </sc-table-column>

      <sc-table-column
        label="Status"
        field="status"
        width="120">
        {{ props.row.processing_status_description }}
      </sc-table-column>

      <sc-table-column
        label="Mensagem"
        field="message"
        :centered="false">
        <span v-html="props.row.message.replace(/[\n\r]/g, '<br />')"></span>
      </sc-table-column>
    </template>

    <template slot="empty">
      <sc-table-empty />
    </template>
  </sc-table>
</template>

<script>
  import {
    ScTable,
    ScTableColumn,
    ScTableEmpty,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState } = createNamespacedHelpers('analytic/logsTracking');

  export default {
    name: 'tab-logs-tracking-lote-detail-history',
    computed: {
      ...mapState([
        'lote',
      ]),
    },
    components: {
      ScTable,
      ScTableColumn,
      ScTableEmpty,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-lote-detail/tabs/tab-logs-tracking-lote-detail-history/TabLogsTrackingLoteDetailHistory.vue